document.addEventListener('DOMContentLoaded', function() {
  // Fonction pour initialiser une instance de la section
  function initializeSection(sectionId) {
    const gridContainer = document.getElementById('tbg-grid-' + sectionId);
    if (!gridContainer) {
      return null;
    }

    // Récupérer les données de cette section
    const sectionData = window.TBG_SECTIONS_DATA && window.TBG_SECTIONS_DATA[sectionId];
    if (!sectionData) {
      gridContainer.innerHTML = '<p style="text-align:center;padding:20px;">Aucune donnée disponible pour cette section.</p>';
      return null;
    }

    const TopBlogGamingManager = {
      sectionId: sectionId,
      gridContainer: gridContainer,
      videos: [],
      filteredVideos: [],
      modal: null,
      iframe: null,
      closeBtn: null,
      synopsisCharLimit: 200,
      currentTagFilter: 'all',
      currentYearFilter: 'all',

      init: function() {
      // Récupérer les paramètres avec valeurs par défaut
      this.synopsisCharLimit = 200;
      this.synopsisCharLimitSingleVideo = 450; // Limite pour 1 vidéo desktop
      this.synopsisCharLimitMobileMultiple = 200; // Limite pour mobile vue multiple
      this.synopsisCharLimitMobileSingle = 200; // Limite pour mobile vue single
      this.btnAmazonText = 'Amazon';
      this.btnInstantGamingText = 'Instant Gaming';
      this.btnLoadedText = 'Loaded';
      this.btnUnavailableText = 'Indisponible';
      this.buyZoneTitleText = 'Achetez vos jeux au meilleur prix :';
      this.buyTitleUnderline = false;
      this.buySubtitleText = '';
      this.buyFooterText = '';
      this.critiqueLinkText = 'Consultez ici notre test';
      this.showBadge = true;
      this.synopsisToggleReadMoreText = 'Lire plus';
      this.synopsisToggleReadLessText = 'Lire moins';
      
      // Utiliser les données de la section
      const settings = sectionData.settings || {};
      this.synopsisCharLimit = settings.synopsisCharLimit || this.synopsisCharLimit;
      this.synopsisCharLimitMobileMultiple = settings.synopsisCharLimitMobileMultiple || this.synopsisCharLimitMobileMultiple;
      this.synopsisCharLimitMobileSingle = settings.synopsisCharLimitMobileSingle || this.synopsisCharLimitMobileSingle;
      this.btnAmazonText = settings.btnAmazonText || this.btnAmazonText;
      this.btnInstantGamingText = settings.btnInstantGamingText || this.btnInstantGamingText;
      this.btnLoadedText = settings.btnLoadedText || this.btnLoadedText;
      this.btnUnavailableText = settings.btnUnavailableText || this.btnUnavailableText;
      this.buyZoneTitleText = settings.buyZoneTitleText || this.buyZoneTitleText;
      this.buyTitleUnderline = settings.buyTitleUnderline || false;
      this.buySubtitleText = settings.buySubtitleText || '';
      this.buyFooterText = settings.buyFooterText || '';
      this.critiqueLinkText = settings.critiqueLinkText || this.critiqueLinkText;
      this.showBadge = settings.showBadge !== false;
      this.synopsisToggleReadMoreText = settings.synopsisToggleReadMoreText || this.synopsisToggleReadMoreText;
      this.synopsisToggleReadLessText = settings.synopsisToggleReadLessText || this.synopsisToggleReadLessText;

      // Récupérer les vidéos sélectionnées
      if (sectionData.videos && sectionData.videos.length > 0) {
        this.videos = sectionData.videos.sort((a, b) => a.order - b.order);
      } else {
        this.gridContainer.innerHTML = '<p style="text-align:center;padding:20px;">Aucune vidéo sélectionnée. Ajoutez des vidéos dans le theme editor.</p>';
        return;
      }

      // Créer la modal
      this.createModal();

      // Générer les filtres
      this.setupFilters();

      // Afficher toutes les vidéos initialement
      this.filteredVideos = [...this.videos];
      this.renderVideos();
    },

    createModal: function() {
      this.modal = document.getElementById('videoModal');
      this.closeBtn = document.getElementById('closeModal');
      this.iframe = this.modal ? this.modal.querySelector('iframe') : null;

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.closeModal());
      }

      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.closeModal();
          }
        });
      }
    },

    setupFilters: function() {
      const filterSelect = document.getElementById('tbg-tag-filter-' + this.sectionId);
      const yearFilterSelect = document.getElementById('tbg-year-filter-' + this.sectionId);
      const resetBtn = document.getElementById('tbg-reset-' + this.sectionId);

      if (!filterSelect) {
        return;
      }

      // Collecter tous les tags uniques
      const allTags = new Set();
      const allYears = new Set();
      
      this.videos.forEach(video => {
        // Tags
        if (video.tags) {
          const tags = typeof video.tags === 'string' 
            ? video.tags.split(',').map(t => t.trim()) 
            : video.tags;
          
          tags.forEach(tag => {
            if (tag && tag.trim()) {
              allTags.add(tag.trim());
            }
          });
        }
        
        // Années
        if (video.date_sortie && video.date_sortie.trim()) {
          const year = this.extractYear(video.date_sortie);
          if (year) {
            allYears.add(year);
          }
        }
      });

      // Ajouter les options de tags
      Array.from(allTags).sort().forEach(tag => {
        const option = document.createElement('option');
        option.value = tag;
        option.textContent = tag;
        filterSelect.appendChild(option);
      });

      // Ajouter les options d'années (si le select existe)
      if (yearFilterSelect) {
        Array.from(allYears).sort((a, b) => b - a).forEach(year => {
          const option = document.createElement('option');
          option.value = year;
          option.textContent = year;
          yearFilterSelect.appendChild(option);
        });
        
        // Événement de filtrage par année
        yearFilterSelect.addEventListener('change', () => {
          this.currentYearFilter = yearFilterSelect.value;
          this.applyFilters();
        });
      }

      // Événement de filtrage par tag
      filterSelect.addEventListener('change', () => {
        this.currentTagFilter = filterSelect.value;
        this.applyFilters();
      });

      // Bouton reset
      if (resetBtn) {
        resetBtn.addEventListener('click', () => {
          filterSelect.value = 'all';
          this.currentTagFilter = 'all';
          
          if (yearFilterSelect) {
            yearFilterSelect.value = 'all';
            this.currentYearFilter = 'all';
          }
          
          this.applyFilters();
        });
      }
    },
    
    extractYear: function(dateStr) {
      // Extraire l'année de différents formats de date
      if (!dateStr) return null;
      
      // Format YYYY-MM-DD ou YYYY/MM/DD
      const match = dateStr.match(/(\d{4})/);
      if (match) {
        return parseInt(match[1], 10);
      }
      
      return null;
    },

    formatDate: function(dateStr) {
      // Convertir YYYY-MM-DD en DD-MM-YYYY
      if (!dateStr) return '';
      
      // Format YYYY-MM-DD
      const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        const year = match[1];
        const month = match[2];
        const day = match[3];
        return `${day}-${month}-${year}`;
      }
      
      // Si le format n'est pas reconnu, retourner la date telle quelle
      return dateStr;
    },

    applyFilters: function() {
      this.filteredVideos = this.videos.filter(video => {
        // Filtre par tag
        let matchTag = true;
        if (this.currentTagFilter !== 'all') {
          if (!video.tags) {
            matchTag = false;
          } else {
            const tags = typeof video.tags === 'string' 
              ? video.tags.split(',').map(t => t.trim()) 
              : video.tags;
            
            matchTag = tags.some(tag => tag.toLowerCase() === this.currentTagFilter.toLowerCase());
          }
        }
        
        // Filtre par année
        let matchYear = true;
        if (this.currentYearFilter !== 'all') {
          if (!video.date_sortie) {
            matchYear = false;
          } else {
            const videoYear = this.extractYear(video.date_sortie);
            matchYear = videoYear === parseInt(this.currentYearFilter, 10);
          }
        }
        
        return matchTag && matchYear;
      });

      this.renderVideos();
    },

    renderVideos: function() {
      this.gridContainer.innerHTML = '';

      if (this.filteredVideos.length === 0) {
        this.gridContainer.innerHTML = '<p style="text-align:center;padding:20px;grid-column:1/-1;">Aucune vidéo ne correspond à ce filtre.</p>';
        this.gridContainer.classList.remove('tbg-single-video-layout');
        this.gridContainer.classList.remove('tbg-single-video-desktop');
        this.gridContainer.classList.remove('tbg-single-video-mobile');
        this.gridContainer.classList.remove('tbg-single-video-border');
        this.gridContainer.classList.remove('tbg-last-row-centered');
        this.gridContainer.classList.remove('tbg-last-single-mobile');
        return;
      }

      const isDesktop = window.innerWidth > 768;
      const videoCount = this.filteredVideos.length;

      // Une carte pleine largeur par ligne, quel que soit le nombre de jeux.
      this.gridContainer.classList.add('tbg-single-video-layout');
      this.gridContainer.classList.add('tbg-one-per-row');
      this.gridContainer.classList.remove('tbg-last-row-centered');
      this.gridContainer.classList.remove('tbg-last-single-mobile');

      if (isDesktop) {
        this.gridContainer.classList.add('tbg-single-video-desktop');
        this.gridContainer.classList.remove('tbg-single-video-mobile');
      } else {
        this.gridContainer.classList.add('tbg-single-video-mobile');
        this.gridContainer.classList.remove('tbg-single-video-desktop');
      }

      const settings = window.TBG_SECTIONS_DATA
        && window.TBG_SECTIONS_DATA[this.sectionId]
        && window.TBG_SECTIONS_DATA[this.sectionId].settings;
      if (isDesktop && settings && settings.singleVideoBorder) {
        this.gridContainer.classList.add('tbg-single-video-border');
      } else {
        this.gridContainer.classList.remove('tbg-single-video-border');
      }

      // Toutes les cartes utilisent le rendu éditorial pleine largeur.
      this.filteredVideos.forEach(video => {
        const card = this.createVideoCard(video, true);
        this.gridContainer.appendChild(card);
      });

      // Uniformiser les boutons d'affiliation séparément dans chaque carte.
      if (isDesktop && this.gridContainer.classList.contains('tbg-single-video-desktop')) {
        const applyButtonWidths = () => {
          this.gridContainer.querySelectorAll('.tbg-video-card').forEach(videoCard => {
            const allButtons = Array.from(videoCard.querySelectorAll('.tbg-buy-buttons .tbg-btn-primary'));
            if (allButtons.length === 0) return;

            const buttonWidth = Math.max(...allButtons.map(button => {
              const tempSpan = document.createElement('span');
              const buttonStyles = window.getComputedStyle(button);
              tempSpan.style.visibility = 'hidden';
              tempSpan.style.position = 'absolute';
              tempSpan.style.whiteSpace = 'nowrap';
              tempSpan.style.fontSize = buttonStyles.fontSize;
              tempSpan.style.fontFamily = buttonStyles.fontFamily;
              tempSpan.style.fontWeight = buttonStyles.fontWeight;
              tempSpan.textContent = button.textContent.trim();
              document.body.appendChild(tempSpan);
              const width = tempSpan.offsetWidth + 6;
              document.body.removeChild(tempSpan);
              return width;
            }));

            allButtons.forEach(button => {
              button.style.width = buttonWidth + 'px';
              button.style.minWidth = buttonWidth + 'px';
              button.style.paddingLeft = '3px';
              button.style.paddingRight = '3px';
              button.style.boxSizing = 'border-box';
            });
          });
        };

        setTimeout(applyButtonWidths, 100);
      }
    },

    createVideoCard: function(video, isSingleVideo = false) {
      const card = document.createElement('div');
      card.className = 'tbg-video-card';
      const isFutureSortie = video.contentType === 'future_sortie';
      const isStandardGame = video.contentType === 'jeu_standard';
      const usesCustomImage = isFutureSortie || isStandardGame;
      const playableVideoId = usesCustomImage
        ? this.extractYouTubeId(video.trailerUrl)
        : video.videoId;

      if (isFutureSortie) {
        card.classList.add('tbg-future-card');
      }
      if (isStandardGame) {
        card.classList.add('tbg-standard-card');
      }
      if (playableVideoId) {
        card.setAttribute('data-video-id', playableVideoId);
      }

      // Conteneur miniature
      const thumbnailContainer = document.createElement('div');
      thumbnailContainer.className = 'tbg-thumbnail-container';

      // Miniature
      const thumbnail = document.createElement('img');
      thumbnail.className = 'tbg-thumbnail';
      thumbnail.src = playableVideoId
        ? `https://img.youtube.com/vi/${playableVideoId}/maxresdefault.jpg`
        : (usesCustomImage ? (video.imageUrl || '') : '');
      thumbnail.alt = video.imageAlt || video.title || '';
      thumbnail.loading = 'lazy';
      thumbnailContainer.appendChild(thumbnail);

      // Tags vidéo sur la miniature
      if (video.tags && video.tags.length > 0) {
        const tagsContainer = document.createElement('div');
        tagsContainer.className = 'tbg-video-tags';
        
        const tags = typeof video.tags === 'string' 
          ? video.tags.split(',').map(t => t.trim())
          : video.tags;
        
        tags.forEach(tag => {
          if (tag && tag.trim()) {
            const tagElement = document.createElement('span');
            tagElement.className = 'tbg-video-tag';
            tagElement.textContent = tag.trim();
            tagsContainer.appendChild(tagElement);
          }
        });
        
        thumbnailContainer.appendChild(tagsContainer);
      }

      // Badge numéro
      // Le CSS gère l'affichage selon desktop/mobile et single/multi
      // Desktop multi + Mobile all: sur miniature
      // Desktop single: en haut à droite du container (créé dans renderVideos)
      if (this.showBadge !== false) {
        const badge = document.createElement('div');
        badge.className = 'tbg-badge';
        badge.textContent = video.order;
        thumbnailContainer.appendChild(badge);
      }

      // Film GamingHub ou trailer officiel lorsqu'il existe.
      if (playableVideoId) {
        const playButton = document.createElement('div');
        playButton.className = 'tbg-play-button';
        playButton.addEventListener('click', () => this.openModal(playableVideoId));
        thumbnailContainer.appendChild(playButton);
        thumbnail.addEventListener('click', () => this.openModal(playableVideoId));
      } else if (usesCustomImage && video.lien_article_critique) {
        thumbnail.classList.add('tbg-thumbnail--linked');
        thumbnail.addEventListener('click', () => {
          window.location.href = video.lien_article_critique;
        });
      }

      card.appendChild(thumbnailContainer);

      // Pour single video : créer un conteneur séparé pour titre + date
      if (isSingleVideo) {
        const videoHeader = document.createElement('div');
        videoHeader.className = 'tbg-video-header';

        // Titre (toujours en H3 pour le SEO, cliquable si lien article critique disponible)
        const title = document.createElement('h3');
        title.className = 'tbg-video-title';
        
        if (video.lien_article_critique && video.lien_article_critique.trim()) {
          // Créer un lien à l'intérieur du H3 si l'article critique existe
          const titleLink = document.createElement('a');
          titleLink.href = video.lien_article_critique;
          titleLink.target = '_blank';
          titleLink.rel = 'noopener';
          titleLink.textContent = video.title || '';
          title.appendChild(titleLink);
        } else {
          // Sinon juste le texte dans le H3
          title.textContent = video.title || '';
        }
        videoHeader.appendChild(title);

        // Date de sortie officielle
        if (video.date_sortie && video.date_sortie.trim()) {
          const dateDiv = document.createElement('div');
          dateDiv.className = 'tbg-date-sortie';
          const formattedDate = video.date_is_approximate
            ? video.date_sortie
            : this.formatDate(video.date_sortie);
          dateDiv.textContent = `Date de sortie : ${formattedDate}`;
          videoHeader.appendChild(dateDiv);
        }

        card.appendChild(videoHeader);
      }

      // Badge supprimé d'ici, il est ajouté au gridContainer maintenant

      // Infos vidéo (synopsis, critique, buy zone)
      const videoInfo = document.createElement('div');
      videoInfo.className = 'tbg-video-info';

      // Titre et date pour les cartes normales (pas single video)
      if (!isSingleVideo) {
        // Titre (toujours en H3 pour le SEO, cliquable si lien article critique disponible)
        const title = document.createElement('h3');
        title.className = 'tbg-video-title';
        
        if (video.lien_article_critique && video.lien_article_critique.trim()) {
          // Créer un lien à l'intérieur du H3 si l'article critique existe
          const titleLink = document.createElement('a');
          titleLink.href = video.lien_article_critique;
          titleLink.target = '_blank';
          titleLink.rel = 'noopener';
          titleLink.textContent = video.title || '';
          title.appendChild(titleLink);
        } else {
          // Sinon juste le texte dans le H3
          title.textContent = video.title || '';
        }
        videoInfo.appendChild(title);

        // Date de sortie officielle
        if (video.date_sortie && video.date_sortie.trim()) {
          const dateDiv = document.createElement('div');
          dateDiv.className = 'tbg-date-sortie';
          const formattedDate = video.date_is_approximate
            ? video.date_sortie
            : this.formatDate(video.date_sortie);
          dateDiv.textContent = `Date de sortie : ${formattedDate}`;
          videoInfo.appendChild(dateDiv);
        }
      }

      // Synopsis
      if (usesCustomImage && video.synopsisHtml && video.synopsisHtml.trim()) {
        const synopsisDiv = this.createRichSynopsisBlock(video.synopsisHtml, isSingleVideo);
        videoInfo.appendChild(synopsisDiv);
      } else if (video.synopsis && video.synopsis.trim()) {
        const synopsisDiv = this.createSynopsisBlock(video.synopsis, isSingleVideo);
        videoInfo.appendChild(synopsisDiv);
      }

      // Lien article critique
      if (video.lien_article_critique && video.lien_article_critique.trim()) {
        const critiqueContainer = document.createElement('div');
        critiqueContainer.className = 'tbg-critique-container';

        const icon = document.createElement('img');
        icon.className = 'tbg-critique-icon';
        icon.src = 'https://cdn.shopify.com/s/files/1/0859/8490/3494/files/Barre_laterale_favicon.png?v=1728567755';
        icon.alt = '';
        icon.width = 16;
        icon.height = 16;
        critiqueContainer.appendChild(icon);

        const link = document.createElement('a');
        link.className = 'tbg-critique-link';
        link.href = video.lien_article_critique;
        link.textContent = isFutureSortie
          ? 'Découvrir cette future sortie'
          : (isStandardGame ? 'Découvrir ce jeu' : (this.critiqueLinkText || 'Consultez ici notre test'));
        link.target = '_blank';
        link.rel = 'noopener';
        critiqueContainer.appendChild(link);

        videoInfo.appendChild(critiqueContainer);
      }

      // Zone d'achat
      const hasAffiliateLink = [video.lien_amazon, video.lien_instant_gaming, video.lien_loaded]
        .some(link => typeof link === 'string' && link.trim());
      if (!isStandardGame || hasAffiliateLink) {
        const buyZone = this.createBuyZone(video);
        videoInfo.appendChild(buyZone);
      }

      card.appendChild(videoInfo);

      return card;
    },

    createRichSynopsisBlock: function(html, isSingleVideo = false) {
      const synopsisDiv = document.createElement('div');
      synopsisDiv.className = 'tbg-synopsis tbg-rich-description';

      const richContent = document.createElement('div');
      richContent.className = 'tbg-synopsis__text tbg-synopsis__text--rich';
      if (isSingleVideo) {
        richContent.classList.add('tbg-synopsis__text--rich-single');
      }
      richContent.innerHTML = processBoldText(html);
      richContent.querySelectorAll('h1, h2, h3').forEach(heading => {
        const normalizedHeading = document.createElement('h4');
        normalizedHeading.className = heading.className;
        normalizedHeading.innerHTML = heading.innerHTML;
        heading.replaceWith(normalizedHeading);
      });
      synopsisDiv.appendChild(richContent);

      const plainText = richContent.textContent || '';
      const isDesktop = window.innerWidth > 768;
      let charLimit;

      if (isSingleVideo && isDesktop) {
        charLimit = this.synopsisCharLimitSingleVideo;
      } else if (isSingleVideo && !isDesktop) {
        charLimit = this.synopsisCharLimitMobileSingle;
      } else if (!isDesktop) {
        charLimit = this.synopsisCharLimitMobileMultiple;
      } else {
        charLimit = this.synopsisCharLimit;
      }

      if (plainText.trim().length > charLimit) {
        richContent.classList.add('is-collapsed');

        const toggleButton = document.createElement('button');
        toggleButton.type = 'button';
        toggleButton.className = 'tbg-synopsis__toggle';
        toggleButton.textContent = this.synopsisToggleReadMoreText || 'Voir plus';
        toggleButton.setAttribute('aria-expanded', 'false');

        toggleButton.addEventListener('click', () => {
          const willExpand = richContent.classList.contains('is-collapsed');
          richContent.classList.toggle('is-collapsed', !willExpand);
          toggleButton.textContent = willExpand
            ? (this.synopsisToggleReadLessText || 'Voir moins')
            : (this.synopsisToggleReadMoreText || 'Voir plus');
          toggleButton.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
        });

        synopsisDiv.appendChild(toggleButton);
      }

      return synopsisDiv;
    },

    extractYouTubeId: function(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }

      const match = url.match(
        /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/
      );
      return match ? match[1] : '';
    },

    createSynopsisBlock: function(synopsis, isSingleVideo = false) {
      const synopsisDiv = document.createElement('div');
      synopsisDiv.className = 'tbg-synopsis';

      const textSpan = document.createElement('div');
      textSpan.className = 'tbg-synopsis__text';
      
      // Convertir les \n littéraux (échappés depuis JSON) en vrais sauts de ligne
      // Remplacer \\n (échappé dans JSON) et \n (si déjà converti) par de vrais sauts de ligne
      let synopsisWithBreaks = synopsis.replace(/\\n/g, '\n').replace(/\\r\\n/g, '\r\n').replace(/\\r/g, '\r');
      
      // Traiter les sauts de ligne pour créer des paragraphes
      let processedSynopsis = processLineBreaks(synopsisWithBreaks);
      // Traiter le markdown pour convertir **texte** en <strong>texte</strong>
      processedSynopsis = processBoldText(processedSynopsis);
      
      // Utiliser une limite différente selon le contexte
      const isDesktop = window.innerWidth > 768;
      let charLimit;
      
      if (isSingleVideo && isDesktop) {
        // Single video desktop : limite spéciale
        charLimit = this.synopsisCharLimitSingleVideo;
      } else if (isSingleVideo && !isDesktop) {
        // Single video mobile : limite mobile single spécifique
        charLimit = this.synopsisCharLimitMobileSingle;
      } else if (!isDesktop && !isSingleVideo) {
        // Mobile vue multiple : limite mobile multiple spécifique
        charLimit = this.synopsisCharLimitMobileMultiple;
      } else {
        // Desktop vue multiple : limite desktop
        charLimit = this.synopsisCharLimit;
      }
      
      // Pour calculer la longueur, utiliser le texte sans HTML
      const textLength = synopsis.length;
      const isTruncatable = textLength > charLimit;
      
      if (isTruncatable) {
        // Tronquer le texte original (sans HTML) à la limite de caractères
        // Convertir d'abord les \n littéraux en vrais sauts de ligne
        let synopsisForTruncate = synopsis.replace(/\\n/g, '\n').replace(/\\r\\n/g, '\r\n').replace(/\\r/g, '\r');
        const truncatedText = synopsisForTruncate.substring(0, charLimit) + '...';
        const fullText = processedSynopsis;
        // Traiter les sauts de ligne et le markdown pour le texte tronqué
        let truncatedProcessed = processLineBreaks(truncatedText);
        truncatedProcessed = processBoldText(truncatedProcessed);
        
        textSpan.innerHTML = truncatedProcessed;
        textSpan.setAttribute('data-full-text', fullText);
        textSpan.setAttribute('data-truncated-text', truncatedProcessed);

        const toggleBtn = document.createElement('button');
        toggleBtn.className = 'tbg-synopsis__toggle';
        toggleBtn.textContent = this.synopsisToggleReadMoreText || 'Lire plus';
        
        toggleBtn.addEventListener('click', () => {
          if (textSpan.innerHTML === truncatedProcessed) {
            textSpan.innerHTML = fullText;
            toggleBtn.textContent = this.synopsisToggleReadLessText || 'Lire moins';
          } else {
            textSpan.innerHTML = truncatedProcessed;
            toggleBtn.textContent = this.synopsisToggleReadMoreText || 'Lire plus';
          }
        });

        synopsisDiv.appendChild(textSpan);
        synopsisDiv.appendChild(toggleBtn);
      } else {
        textSpan.innerHTML = processedSynopsis;
        synopsisDiv.appendChild(textSpan);
      }

      return synopsisDiv;
    },

    createBuyZone: function(video) {
      const buyZone = document.createElement('div');
      buyZone.className = 'tbg-buy-zone';

      const title = document.createElement('h4');
      title.className = 'tbg-buy-title';
      title.textContent = this.buyZoneTitleText || 'Achetez vos jeux au meilleur prix :';
      buyZone.appendChild(title);

      // Texte sous le titre (optionnel)
      if (this.buySubtitleText && this.buySubtitleText.trim()) {
        const subtitle = document.createElement('p');
        subtitle.className = 'tbg-buy-subtitle';
        subtitle.textContent = this.buySubtitleText;
        buyZone.appendChild(subtitle);
      }

      const buttonsContainer = document.createElement('div');
      buttonsContainer.className = 'tbg-buy-buttons';

      const hasAmazon = video.lien_amazon && video.lien_amazon.trim();
      const hasIG = video.lien_instant_gaming && video.lien_instant_gaming.trim();
      const hasLoaded = video.lien_loaded && video.lien_loaded.trim();

      if (hasAmazon) {
        const amazonBtn = document.createElement('a');
        amazonBtn.className = 'tbg-btn-primary';
        amazonBtn.href = video.lien_amazon;
        amazonBtn.textContent = this.btnAmazonText || 'Amazon';
        amazonBtn.target = '_blank';
        amazonBtn.rel = 'noopener';
        buttonsContainer.appendChild(amazonBtn);
      }

      if (hasIG) {
        const igBtn = document.createElement('a');
        igBtn.className = 'tbg-btn-primary';
        igBtn.href = video.lien_instant_gaming;
        igBtn.textContent = this.btnInstantGamingText || 'Instant Gaming';
        igBtn.target = '_blank';
        igBtn.rel = 'noopener';
        buttonsContainer.appendChild(igBtn);
      }

      if (hasLoaded) {
        const loadedBtn = document.createElement('a');
        loadedBtn.className = 'tbg-btn-primary';
        loadedBtn.href = video.lien_loaded;
        loadedBtn.textContent = this.btnLoadedText || 'Loaded';
        loadedBtn.target = '_blank';
        loadedBtn.rel = 'noopener';
        buttonsContainer.appendChild(loadedBtn);
      }

      // Si aucun lien, afficher "Indisponible"
      if (!hasAmazon && !hasIG && !hasLoaded) {
        const ghostBtn = document.createElement('button');
        ghostBtn.className = 'tbg-btn-primary tbg-btn-ghost';
        ghostBtn.textContent = this.btnUnavailableText || 'Indisponible';
        ghostBtn.disabled = true;
        buttonsContainer.appendChild(ghostBtn);
      }

      buyZone.appendChild(buttonsContainer);

      // Texte sous les boutons (optionnel)
      if (this.buyFooterText && this.buyFooterText.trim()) {
        const footer = document.createElement('p');
        footer.className = 'tbg-buy-footer';
        footer.textContent = this.buyFooterText;
        buyZone.appendChild(footer);
      }

      return buyZone;
    },

    openModal: function(videoId) {
      if (!videoId) {
        return;
      }

      // Vérifier si une fonction globale openVideoModal existe (depuis render-video-custom.js)
      if (typeof window.openVideoModal === 'function') {
        window.openVideoModal(videoId);
        return;
      }

      // Sinon, utiliser notre propre modal
      if (!this.modal || !this.iframe) {
        return;
      }

      const videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0`;
      this.iframe.src = videoUrl;
      this.modal.classList.add('active');
      this.modal.style.display = 'block';

      // Bloquer le scroll
      document.body.style.overflow = 'hidden';
    },

    closeModal: function() {
      if (!this.modal || !this.iframe) return;

      this.iframe.src = '';
      this.modal.classList.remove('active');
      this.modal.style.display = 'none';

      // Restaurer le scroll
      document.body.style.overflow = '';
    }
    };

    // Initialiser cette instance
    TopBlogGamingManager.init();
    
    return TopBlogGamingManager;
  }

  // Initialiser toutes les instances de la section sur la page
  function initializeAllSections() {
    // Attendre que les données soient disponibles
    if (!window.TBG_SECTIONS_DATA) {
      setTimeout(initializeAllSections, 100);
      return;
    }

    // Trouver toutes les grilles avec data-section-id
    const grids = document.querySelectorAll('.tbg-grid[data-section-id]');
    
    grids.forEach(function(grid) {
      const sectionId = grid.getAttribute('data-section-id');
      if (sectionId && !grid.dataset.initialized) {
        const manager = initializeSection(sectionId);
        if (manager) {
          grid.dataset.initialized = 'true';
        }
      }
    });
  }

  // Initialiser au chargement
  initializeAllSections();

  // Réinitialiser quand Shopify recharge une section (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const sectionGrid = event.target.querySelector('.tbg-grid[data-section-id]');
    if (sectionGrid) {
      const sectionId = sectionGrid.getAttribute('data-section-id');
      if (sectionId) {
        sectionGrid.dataset.initialized = 'false';
        // Attendre que les données soient mises à jour
        setTimeout(function() {
          initializeSection(sectionId);
          sectionGrid.dataset.initialized = 'true';
        }, 100);
      }
    }
  });
});

/**
 * Traite le texte en gras (**texte**) pour le convertir en <strong>texte</strong>
 */
function processBoldText(text) {
  if (!text) return '';
  // Convertir **texte** en <strong>texte</strong>
  return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
}

/**
 * Traite les sauts de ligne pour créer des paragraphes séparés
 */
function processLineBreaks(text) {
  if (!text) return '';
  
  // Nettoyer le texte : supprimer les \n en fin de chaîne
  let cleanText = text.replace(/\n+$/, '').replace(/\r+$/, '');
  
  // Vérifier s'il y a des sauts de ligne
  if (!cleanText.includes('\n') && !cleanText.includes('\r')) {
    // Pas de sauts de ligne, retourner le texte tel quel dans un paragraphe
    return `<p>${cleanText}</p>`;
  }
  
  // Diviser par les sauts de ligne (\n ou \r\n)
  const lines = cleanText.split(/\r?\n/);
  
  // Créer des paragraphes pour chaque ligne non vide
  const paragraphs = lines
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .map(line => `<p>${line}</p>`)
    .join('');
  
  // Si aucun paragraphe n'a été créé, retourner le texte original dans un paragraphe
  return paragraphs || `<p>${cleanText}</p>`;
}

/**
 * Traite le markdown dans les zones de texte enrichi de la section
 */
function processRichTextMarkdown() {
  // Traiter le texte enrichi de l'en-tête (.tbg-richtext)
  const richTextElements = document.querySelectorAll('.tbg-richtext');
  
  richTextElements.forEach(element => {
    // Traiter tous les paragraphes, divs et autres éléments de texte (mais pas les titres Hn)
    const textContainers = element.querySelectorAll('p, div, span, li');
    
    textContainers.forEach(container => {
      // Vérifier que le conteneur n'est pas dans un titre
      if (container.closest('h1, h2, h3, h4, h5, h6')) {
        return;
      }
      
      // Traiter le contenu texte du conteneur
      const walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      
      const textNodes = [];
      let node;
      while (node = walker.nextNode()) {
        if (node.textContent.trim() && node.textContent.includes('**')) {
          textNodes.push(node);
        }
      }
      
      textNodes.forEach(textNode => {
        const processedHTML = processBoldText(textNode.textContent);
        if (processedHTML !== textNode.textContent) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = processedHTML;
          const parent = textNode.parentNode;
          while (tempDiv.firstChild) {
            parent.insertBefore(tempDiv.firstChild, textNode);
          }
          parent.removeChild(textNode);
        }
      });
    });
  });
}

// Traiter le markdown au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  // Attendre un peu pour que le contenu soit rendu
  setTimeout(() => {
    processRichTextMarkdown();
  }, 100);
});

// Traiter aussi après le rendu des vidéos (si la section est chargée dynamiquement)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      processRichTextMarkdown();
    }, 500);
  });
} else {
  setTimeout(() => {
    processRichTextMarkdown();
  }, 500);
}

